import { connect } from "react-redux";
import { RootState } from "../../../../reducers";
import { SavingsOffer as Component, SavingsOfferProps } from "./SavingsOffer.component";
import { getDisplayCode } from "../../../../selector";
import { createCouponForPepRequest } from "../../actions";
import { getCouponPrecursor, getDeviceType } from "../../selectors";

const mapStateToProps = (state: RootState) =>
  ({
    displayCode: getDisplayCode(state),
    deviceType: getDeviceType(state),
    couponPrecursor: getCouponPrecursor(state),
  } as Pick<SavingsOfferProps, "couponPrecursor" | "deviceType" | "displayCode">);

const mapDispatchToProps = {
  onClick: createCouponForPepRequest
} as Pick<SavingsOfferProps, "onClick">;

export const SavingsOffer = connect(mapStateToProps, mapDispatchToProps)(Component);
